import { Box, Flex, Text, Button } from '@skin-seoul/design-system';

export const Overlay = ({
  children,
  isOpen,
  onClick,
}: {
  children: React.ReactNode;
  isOpen: boolean;
  onClick: (e: React.MouseEvent) => void;
}) => (
  <Box
    position="fixed"
    top="0"
    left="0"
    right="0"
    bottom="0"
    bg="rgba(0, 0, 0, 0.5)"
    display={isOpen ? 'flex' : 'none'}
    justifyContent="center"
    alignItems="flex-end"
    zIndex="1000"
    p="0"
    animation="fade-in 0.2s ease-in-out"
    onClick={onClick}
  >
    {children}
  </Box>
);

export const Container = ({ children, isOpen: _isOpen }: { children: React.ReactNode; isOpen: boolean }) => (
  <Box
    width="100%"
    bg="white"
    borderTopLeftRadius="26px"
    borderTopRightRadius="26px"
    p="0"
    paddingBottom="64px"
    position="relative"
    maxH="80dvh"
    height="auto"
    display="flex"
    flexDirection="column"
    animation="slide-from-bottom-full 0.3s ease-in-out"
    overflow="hidden"
  >
    {children}
  </Box>
);

export const Header = ({ children }: { children: React.ReactNode }) => (
  <Flex justify="space-between" align="center" position="sticky" top="0" bg="white" zIndex="10" p="16px 24px 16px 24px">
    {children}
  </Flex>
);

export const Title = ({ children }: { children: React.ReactNode }) => (
  <Text style={{ fontSize: '16px' }} fontWeight="500" color="#2e2e2e" m="0">
    {children}
  </Text>
);

export const CloseButton = ({ children, onClick }: { children: React.ReactNode; onClick: () => void }) => (
  <Button
    bg="none"
    border="none"
    p="8px"
    cursor="pointer"
    color="#6e6e6e"
    style={{ fontSize: '24px', lineHeight: '1' }}
    display="flex"
    alignItems="center"
    justifyContent="center"
    onClick={onClick}
  >
    {children}
  </Button>
);

export const Content = ({ children, hasHeader }: { children: React.ReactNode; hasHeader?: boolean }) => (
  <Box
    width="100%"
    overflowY="auto"
    flex="1"
    p={hasHeader ? '0 24px 24px 24px' : '40px 24px 80px 24px'}
    css={{
      WebkitOverflowScrolling: 'touch',
    }}
  >
    {children}
  </Box>
);
